import { inject, makeStateKey, TransferState } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { GraphqlService } from '@app/core/services/graphql/graphql.service';

export const pageAssemblyResolver: ResolveFn<any> = async (route) => {
  const graphql = inject(GraphqlService);
  const transferState = inject(TransferState);

  const slugParam = route.paramMap.get('slug') ?? '';
  const nested = route.paramMap.get('nested') ?? '';
  const slug = nested ? `${slugParam}/${nested}` : slugParam;

  if (!slug) return { slug: '', base: null, seo: null };

  // Create a unique key for this page's data
  const DATA_KEY = makeStateKey<any>('PAGE_DATA_' + slug);

  //Check if data exists in TransferState (sent from Server)
  if (transferState.hasKey(DATA_KEY)) {
    const data = transferState.get(DATA_KEY, null);
    transferState.remove(DATA_KEY); // Clear cache after using
    return data;
  }

  // SERVER (or Client fallback): Fetch data
  try {
    const resp = (await firstValueFrom(
      graphql.getPageAssemblyNestedTask(slug),
    )) as any;

    const base = resp?.data?.pageAssemblyCollection?.items?.[0] ?? null;

    const seo = {
      title: base?.pageTitle?.trim?.() || 'Associate Schools Programme',
      description:
        base?.metaDescription?.trim?.() ||
        'Discover more about the RSC Associate Schools Programme.',
      image:
        base?.image?.url ||
        'https://associateschools.rsc.org.uk/assets/images/rsc_logo.png',
      url: `https://associateschools.rsc.org.uk/${slug}`,
    };

    const result = { slug, base, seo };

    transferState.set(DATA_KEY, result);

    return result;
  } catch (err) {
    console.error('Resolver failed for slug:', slug, err);
    return { slug, base: null, seo: null };
  }
};
